import { Component, OnInit, Output, EventEmitter, Inject, ViewChildren, QueryList } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatSelect, MatSelectChange } from '@angular/material';
import { Globals } from 'src/app/libraries/globals';
import { CapacitacionesTiposService } from 'src/app/services/capacitacionesTipos/capacitacionesTipos.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-filtros',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.css']
})
export class CapacitacionesIndexFiltrosComponent implements OnInit {

  @ViewChildren('sltFilter') sltFilter : QueryList<MatSelect>;

  @Output("onChange") onChange : EventEmitter<any> = new EventEmitter<any>();

  // DATES FILTER
  public txtDateDesde  = new FormControl();
  public txtDateHasta  = new FormControl();

  // FILTERS
  public sltCapacitacionEstatus  = new FormControl();
  public sltCapacitacionGrupo    = new FormControl();
  public sltCapacitacionTipo     = new FormControl();
  public sltInstructor           = new FormControl();
  public sltCoordinador          = new FormControl();
  public sltAreaTematica         = new FormControl();
  public sltEstado               = new FormControl();
  public sltArea                 = new FormControl();
  public sltCreatedAspNetUser    = new FormControl();
  public sltUpdatedAspNetUser    = new FormControl();

  public lstCapacitacionesEstatus  : Array<any> = [];
  public lstCapacitacionesGrupos   : Array<any> = [];
  public lstCapacitacionesTipos    : Array<any> = [];
  public lstInstructores           : Array<any> = [];
  public lstCoordinadores          : Array<any> = [];
  public lstAreasTematicas         : Array<any> = [];
  public lstEstados                : Array<any> = [];
  public lstAreas                  : Array<any> = [];
  public lstCreatedAspNetUser      : Array<any> = [];
  public lstUpdatedAspNetUser      : Array<any> = [];

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
              private objCapacitacionesTiposService : CapacitacionesTiposService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.lstCapacitacionesEstatus = this.data.lstCapacitacionesEstatus;
    this.lstCapacitacionesGrupos  = this.data.lstCapacitacionesGrupos;
    this.lstCapacitacionesTipos   = this.data.lstCapacitacionesTipos;
    this.lstInstructores          = this.data.lstInstructores;
    this.lstCoordinadores         = this.data.lstCoordinadores;
    this.lstAreasTematicas        = this.data.lstAreasTematicas;
    this.lstEstados               = this.data.lstEstados;
    this.lstAreas                 = this.data.lstAreas;
    this.lstCreatedAspNetUser     = this.data.lstCreatedAspNetUser;
    this.lstUpdatedAspNetUser     = this.data.lstUpdatedAspNetUser;

    this.txtDateDesde.setValue(this.data.txtDateDesde);
    this.txtDateHasta.setValue(this.data.txtDateHasta);
    this.sltCapacitacionEstatus.setValue(this.data.sltCapacitacionEstatus);
    this.sltCapacitacionGrupo.setValue(this.data.sltCapacitacionGrupo);
    this.sltCapacitacionTipo.setValue(this.data.sltCapacitacionTipo);
    this.sltInstructor.setValue(this.data.sltInstructor);
    this.sltCoordinador.setValue(this.data.sltCoordinador);
    this.sltAreaTematica.setValue(this.data.sltAreaTematica);
    this.sltEstado.setValue(this.data.sltEstado);
    this.sltArea.setValue(this.data.sltArea);
    this.sltCreatedAspNetUser.setValue(this.data.sltCreatedAspNetUser);
    this.sltUpdatedAspNetUser.setValue(this.data.sltUpdatedAspNetUser);
  }

  // METODOS
  sltCapacitacionGrupo_changeEvent(event : MatSelectChange) {
    this.sltCapacitacionTipo.setValue("");
    this.lstCapacitacionesTipos = [];

    if(Globals.validValue(event.value)) {
      this.getCapacitacionesTipos(event.value);
    }
  }

  // METODOS
  private build() : void {
    this.onChange.emit(this);
  }

  private getCapacitacionesTipos(idCapacitacionGrupo : number) : void {
    
    this.sltCapacitacionGrupo.disable();
    this.sltCapacitacionTipo.disable();

    let objCapacitacionTipo : any =
    {
      idCapacitacionGrupo : idCapacitacionGrupo
    };

    this.objCapacitacionesTiposService.listByIdCapacitacionGrupo(objCapacitacionTipo)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {

          this.lstCapacitacionesTipos = objResponse.result.capacitacionesTipos;
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.sltCapacitacionGrupo.enable();
      this.sltCapacitacionTipo.enable();

    }, error => {

      this.sltCapacitacionGrupo.enable();
      this.sltCapacitacionTipo.enable();

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });
  }

}
